import { Controller } from "stimulus"

export default class extends Controller {
  stopUpload(event) {
    event.preventDefault();
  }
}
